var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.modalInfo.props.component,{tag:"component",attrs:{"param":_vm.param,"second-param":_vm.secondParam},on:{"closed":function($event){return _vm.$emit('closed')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }